// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const CardGrid = require('client-v2/common/components/card-grid')
const { CheckExperiment } = require('client-v2/common/containers/rollouts')

const bem = BemEntity('DiscoverSection')

class DiscoverSection extends React.PureComponent {

  renderGrid() {
    return (
      tag(CardGrid, Object.assign({}, this.props, {
        className: bem.element('grid')
      }))
    )
  }

  renderHeader() {
    if (!this.props.isHeaderVisible) {
      return null
    }
    return tag(CheckExperiment, {
      experimentKey: '*logged_out_top_cta',
      renderWithModifier: modifier => {
        if (modifier === 'c') {
          return this.renderHeaderExperimentC()
        }
        if (modifier === 'b') {
          return this.renderHeaderExperimentB()
        }
        return this.renderHeaderExperimentA()
      }
    })
  }

  renderHeaderExperimentA() {
    return tag('div', {
      className: bem.element('header', { experiment: 'a' })
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Discover your next favorite thing.`
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        `Go deeper into new topics and explore any interest.\n`,
        `Then share with others.`
      )
    )
  }

  renderHeaderExperimentB() {
    return tag('div', {
      className: bem.element('header', { experiment: 'b' })
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Explore Top Picks on Mix`
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        `Mix shows you content matched to your interests,\n`,
        `recommended by friends and community experts.`
      )
    )
  }

  renderHeaderExperimentC() {
    return tag('div', {
      className: bem.element('header', { experiment: 'c' })
    },
      tag('div', {
        className: bem.element('heading')
      },
        `See what the community is collecting`
      )
    )
  }

  renderMoreButton() {
    if (!this.props.isMoreAvailable) {
      return null
    }
    return (
      tag('button', {
        className: bem.element('button'),
        onClick: this.props.onMoreClick
      },
        `Load more`
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        this.renderHeader(),
        this.renderGrid(),
        this.renderMoreButton()
      )
    )
  }
}

DiscoverSection.propTypes = {
  // Flags
  isHeaderVisible: PropTypes.bool,
  isMoreAvailable: PropTypes.bool,
  // Callbacks
  onMoreClick: PropTypes.func
}

module.exports = DiscoverSection
